export default "__VITE_ASSET__6bfad5be__"